import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ice py-5 sm:py-7" data-id="element-34" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-35" data-mp="1he32gdrkuemi">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-36" data-mp="1cf0399ya32mg">
          QUESTIONS <span className="text-tech" data-id="element-37" data-mp="2a2s4cf0ginzb">FRÉQUENTES</span>
        </h2>

        <div className="mt-3 divide-y divide-metal overflow-hidden rounded-xl border border-metal bg-white shadow-sm" data-id="element-38" data-mp="2a05u27m6lude">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <div key={faq.question} data-id="element-39" data-mp="1v4g6i51cl96k" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-tech-soft" data-id="element-40" data-mp="oow1770qnaxk">
                  <span className="font-display text-sm font-bold leading-tight text-navy sm:text-base" data-id="element-41" data-mp="1pkqnzqpzugsh">
                    {faq.question}
                  </span>
                  <Icon className="h-4 w-4 shrink-0 text-tech" strokeWidth={3} aria-hidden="true" data-id="element-42" data-mp="1fnc93vjpy02a" />
                </button>
                {isOpen && <p id={`faq-${i}`} className="px-3 pb-2.5 text-sm leading-snug text-steel" data-id="element-43" data-mp="16nyygzjuz5fz">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}